module.exports = __webpack_public_path__ + "static/media/9.0e388c38.png";